import { useNavigate, useParams } from "react-router-dom";
import SideBarWrapper from "../../components/common/SideBarWrapper";
import Navbar from "../../layout/Navbar";
import React,{ useEffect, useState } from "react";
import { baseURL } from "../../utils/misc";
import useAuth from "../../hooks/useAuth";
import { toast } from "react-toastify";
import BMRRecordsForm from "./BMRRecordsForm";

const BMRRecordsIndex = () => {
    const [workflowData, setWorkflowData] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate('/login');
        }
        // Fetch workflow process data when the component mounts
        const getWorkFlowProcess = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
                toast.warn("You seem to have lost your access token. Please try again later.");
                return;
            }
            const requestOptions = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                }
            };
            // Fetch user data when the component mounts
            fetch(`${baseURL}/workflowrecordactivities`, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        console.error('Error fetching workflow record activities');
                    }
                })
                .then((data) => {
                    // Set the useState valuations with the fetched data
                    setWorkflowData(data);
                })
                .catch((error) => {
                    toast.error("Error fetching workflow record activities.");
                    console.error("Error fetching workflow record activities:", error);
                });
        }
        getWorkFlowProcess();
    }, []);





    return (
        <>



            {/* Page wrapper start */}
            <div className="page-wrapper">

                {/* Sidebar wrapper start */}
                <SideBarWrapper />
                {/* Sidebar wrapper end */}

                {/* Page content start  */}
                <div className="page-content">

                    {/* Header start */}
                    <Navbar />
                    {/* Header end */}

                    {/* Page header start */}
                    <div className="page-header">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Home</li>
                            <li className="breadcrumb-item">BMRs</li>
                        </ol>
                        <ul className="app-actions">
                        </ul>
                    </div>
                    {/* Page header end */}

                    {/* Main container start */}
                    <div className="main-container">
                        <BMRRecordsForm />
                    </div>
                    {/* Main container end */}

                </div>
                {/* Page content end */}

            </div>
            {/* Page wrapper end */}
        </>
    );
}

export default BMRRecordsIndex;